import {
  Notification
} from 'element-ui';

export default {
  error (msg) {
    Notification.error({
      title: '失败提示',
      message: msg,
      showClose: false,
      duration: 2000,
      position: 'bottom-right'
    });
  },
  success (msg) {
    setTimeout(() => {
      Notification.success({
        title: '成功提示',
        message: msg,
        showClose: false,
        duration: 1000,
        position: 'bottom-right'
      });
    }, 300)
  },

}